import { useState } from "react";
import { postContactUs } from "@/actions";
import { emailRegex } from "@/regex";
import { toast } from "react-toastify";

const useContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    type: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "name":
        if (!value.trim()) error = "Name is required";
        else if (value.trim().length < 3) error = "Name must be at least 3 characters";
        break;
      case "email":
        if (!value.trim()) error = "Email is required";
        else if (!emailRegex.test(value)) error = "Please enter a valid email address";
        break;
      case "type":
        if (!value) error = "Please select an enquiry type";
        break;
      case "message":
        if (!value.trim()) error = "Message is required";
        else if (value.trim().length < 10) error = "Message must be at least 10 characters";
        break;
      default:
        break;
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate on change
    const fieldError = validateField(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: fieldError,
    }));
  };

  const handleSelectChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      type: value,
    }));

    const fieldError = validateField("type", value);
    setErrors((prev) => ({
      ...prev,
      type: fieldError,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setErrors({});
    setSuccess(false);

    try {
      const response = await postContactUs(formData);
      if (response?.status == 200) {
        setSuccess(true);
        setErrors({});
        toast.success(response?.message);
        setFormData({
          name: "",
          email: "",
          message: "",
          type: "",
        });
      } else {
        toast.error(response?.message);
      }
    } catch (err) {
      setErrors({ form: err?.message || "Something went wrong. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    errors,
    success,
    handleChange,
    handleSelectChange,
    handleSubmit,
  };
};

export default useContactUs;